export const REQUEST_TRANSACTION_DATA = 'REQUEST_TRANSACTION_DATA';
export const RECEIVE_TRANSACTION_DATA = 'RECEIVE_TRANSACTION_DATA';
export const INVALIDATE_TRANSACTION_DATA = 'INVALIDATE_TRANSACTION_DATA';
